<template>
  <div id="app" class="app-root">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
html,
body,
#app,
.app-root {
  margin: 0;
  min-height: 100%;
  background: #0b0e14;
  color: #e8eaef;
  -webkit-font-smoothing: antialiased;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
</style>
